import {gsap} from "gsap";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);
window.gsap = gsap; //global

console.log('Hey');


/**
 * region functions
 */
function scrollSmoothTo(id) {
    const element = document.getElementById(id);
    if (!element) return;

    gsap.to(window, {
        duration: 2,          // scroll duration in seconds
        scrollTo: {
            y: element,       // scroll to the element
            offsetY: 150       // optional offset from top
        },
        ease: "power2.inOut"
    });

}

window.scrollSmoothTo = scrollSmoothTo;

function scrollSmoothJourneyTo(id) {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
    });
}

window.scrollSmoothJourneyTo = scrollSmoothJourneyTo;

function shareLink(title, url) {
    if (navigator.share) {
        try {
            navigator.share({
                title: title,
                url: url
            })
        } catch (e) {
            console.log("Share canceled", url)
        }
    } else {
        console.warn("Sharing not supported")
    }
}

window.shareLink = shareLink;

function copyClipboard(text, message) {
    navigator.clipboard.writeText(text)
        .then(() => {
            alert(message)
        }).catch(err => {
        console.error("Error copy text to clipboard")
    })
}

window.copyClipboard = copyClipboard

function toggleStatusById(id) {
    let element = document.getElementById(id);
    if (element.dataset.status == 'close') {
        element.dataset.status = 'open';
    } else {
        element.dataset.status = 'close';
    }
}

window.toggleStatusById = toggleStatusById;
function setStatusById (id,status){
    let element = document.getElementById(id);
    if(!element) return;
    element.dataset.status = status;
}
window.setStatusById = setStatusById;
function toggleStatusByClass(el, class_name) {
    if (!el) return;

    let status = el.getAttribute('data-status');
    let class_items = document.getElementsByClassName(class_name);

    for (let item of class_items) {
        item.setAttribute('data-status', 'close');
    }

    if (status == 'open') {
        el.setAttribute('data-status', 'close');
    } else {
        el.setAttribute('data-status', 'open');
    }

}

window.toggleStatusByClass = toggleStatusByClass;

function loadYoutubePlayer(playerId, btnId, videoId) {
    console.log("player_id", playerId, "btn", btnId, "video code", videoId)
    let player;
    const playBtn = document.getElementById(btnId);


    player = new YT.Player(playerId, {
        videoId: videoId,
        playerVars: {
            controls: 1,
            loop: 1,
            playlist: videoId, // required for loop:1 to actually loop a single video
            rel: 0,
            playsinline: 1,
            enablejsapi: 1,
            origin: window.location.origin, // required when enablejsapi=1, otherwise YouTube returns "Error 153"
            widget_referrer: window.location.href
        },
        events: {
            onStateChange: onPlayerStateChange
        }
    });


    playBtn.addEventListener('click', () => {
        player.playVideo();
    });

    function onPlayerStateChange(event) {
        if (event.data === YT.PlayerState.PLAYING) {
            playBtn.classList.add('hidden');
        }
    }
}

window.loadYoutubePlayer = loadYoutubePlayer;
function disableButtonAfterSubmit(){
    let forms = document.getElementsByTagName('form');

    Array.from(forms).forEach(form => {
        form.addEventListener('submit', function(e) {
            const submitButtons = form.querySelectorAll('button[type="submit"]');

            submitButtons.forEach(btn => {
                btn.disabled = true;
            });
        });
    });
}
window.disableButtonAfterSubmit = disableButtonAfterSubmit;
/**
 * endregion functions
 */

window.addEventListener('load', () => {

    //region scrollTo
    const params = new URLSearchParams(window.location.search);
    if (params.has('scrollTo')) {
        setTimeout(() => scrollSmoothTo(params.get('scrollTo')), 200)
    }
    //endregion scrollTo

    disableButtonAfterSubmit();
})
